// extracted by mini-css-extract-plugin
export var modal = "_g4-0";